import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';

@Component({
    selector: 'app-password-strength',
    templateUrl: './password-strength.component.html',
    styleUrls: ['./password-strength.component.scss'],
    standalone: false
})
export class PasswordStrengthComponent implements OnInit {

  constructor() { }

  currentPassStrength: number = 0;
  strengthName: string = "";
  color: string = '';
  @Input() password: FormControl;

  namesForPassStrength = {
    0: "",
    20: "Very weak",
    40: "Weak",
    60: "Medium2",
    80: "Strong",
    100: "Very strong"
  };
  confirmPasswordValue: string;

  ngOnInit(): void {
    this.color = this.getStrengthColor();
    this.trackPasswordChange();
  }

  trackPasswordChange(): void {
    if (this.password) {
      this.password.valueChanges.subscribe({
        next: (data) => {
          this.checkPasswordStrength(data);
          this.color = this.getStrengthColor();
        }
      })
    }
  }

  checkPasswordStrength(password: string) {
    if (!password || password == '') {
      this.currentPassStrength = 0;
      this.strengthName = this.namesForPassStrength[0];
      return;
    }

    let strength = 0;

    strength += Math.min(30, (password.length / 12) * 30);

    if (/[A-Z]/.test(password)) strength += 15;  // Uppercase letters
    if (/[a-z]/.test(password)) strength += 15;  // Lowercase letters
    if (/[0-9]/.test(password)) strength += 20;  // Numbers
    if (/[^A-Za-z0-9]/.test(password)) strength += 20;  // Special chars

    this.currentPassStrength = Math.min(100, Math.round(strength / 20) * 20);

    this.strengthName = this.namesForPassStrength[this.currentPassStrength];


    if (this.password) {
      if (this.currentPassStrength < 100) {
        this.password.setErrors({ weakPassword: true });
      } else {
        this.password.setErrors(null);
      }
    }
  }

  getStrengthColor(): ThemePalette {
    if (this.currentPassStrength < 40) return 'warn';
    if (this.currentPassStrength < 80) return 'accent';
    return 'primary';
  }
}